import { Flag } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ConversationDto } from '@/Domain/api/Conversation/dto/Conversation.dto';
import { Separator } from '@/Domain/components/Shared/Separator/Separator';

type Props = {
  conversation: ConversationDto;
};

export const UnifiedFlagged = ({ conversation }: Props) => {
  const { t } = useTranslation('inbox_v2');

  const unifiedAnalysis = conversation.unified_analysis;

  if (!unifiedAnalysis || !unifiedAnalysis.is_flagged) {
    return null;
  }

  return (
    <>
      <Separator />
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <Flag className="text-red-500 size-4" />
          <p className="font-semibold text-red-500">
            {t('conversation_details.unified_analytics.flagged')}
          </p>
        </div>

        {unifiedAnalysis.flag_reason && (
          <div className="flex flex-col gap-1">
            <p className="text-sm font-medium text-foreground-subtle">
              {t('conversation_details.unified_analytics.flag_reason')}
            </p>
            <p className="text-sm text-foreground-subtle">{unifiedAnalysis.flag_reason}</p>
          </div>
        )}
      </div>
    </>
  );
};
